<app-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  header="{{ '+INSTALLATIONS.INSTALLATION.PANEL.INTERNAL_HYDRAULIC' | translate }}"
  [overlayType]="availableOverlays.InternalHydraulic"
>
  <!-- Temporary comment as Alan request -->
  <!-- <div header class="flex flex-row gap-[4px]">
    <ng-container>
      <ng-container
        *ngIf="getInternalHydraulicStatus$ | async | ready as internalHydraulicStatusPillStatus"
      >
        <ng-container
          *ngIf="
            (internalHydraulicStatusPillStatus | value2: featurePropertyKey.status) ===
            INTERNAL_HYDRAULIC_SCHEDULE_LEVEL.On
          "
        >
          <app-pill data-at-internal-hydraulic-chip [type]="pillType.success">
            {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PUMP_ON_CHIP' | translate }}
          </app-pill>
        </ng-container>
        <ng-container
          *ngIf="
            (internalHydraulicStatusPillStatus | value2: featurePropertyKey.status) ===
            INTERNAL_HYDRAULIC_SCHEDULE_LEVEL.Off
          "
        >
          <app-pill data-at-internal-hydraulic-chip [type]="pillType.secondary">
            {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PUMP_OFF_CHIP' | translate }}
          </app-pill>
        </ng-container>
      </ng-container>
    </ng-container>
  </div> -->

  <!-- heating.sensors.volumetricFlow.allengra -->
  <app-feature-tile
    *ngIf="internalHydraulicHeatingWaterVolumeFlow$ | async | ready as feature"
    data-at-heating-water-volume-flow
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.HEATING_WATER_VOLUME_FLOW' | translate"
    value="{{ feature | ready | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.secondaryCircuit.valves.fourThreeWay -->
  <app-feature-tile
    *ngIf="internalHydraulicFourThreeWayValveActualPosition$ | async | ready as feature"
    data-at-four-three-way-valve-actual-position
    feature
    [label]="
      '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOURTHREE_WAY_VALVE_ACTUAL_POSITION'
        | translate
    "
    value="{{ feature | ready | value2: featurePropertyKey.value | internalHydraulicTranslations }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.boiler.sensors.temperature.commonSupply -->
  <app-feature-tile
    *ngIf="internalHydraulicCommonFlowTemperature$ | async | ready as feature"
    data-at-common-flow-temperature
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.COMMON_FLOW_TEMPERATURE' | translate"
    value="{{ feature | ready | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.sensors.temperature.return -->
  <app-feature-tile
    *ngIf="internalHydraulicReturnTemperature$ | async | ready as feature"
    data-at-common-return-temperature
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.RETURN_TEMPERATURE' | translate"
    value="{{ feature | ready | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>
</app-features-container>
